import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { UPDATE_MARKETPLACE, UPDATE_PAGE_INFO } from 'actions/sync-products';
import { updateField } from 'actions/common';
import {
  getShopifyProducts,
  getWooProducts,
  syncedProducts,
  getShopifyMoreProducts,
  getShopifyProductsCount,
  fetchSyncedProductsCount,
  getWooMoreProducts,
} from 'actions/products';
import Products from 'pages/my-stores/sync-products/Products';

const ProductTabs = () => {
  const dispatch = useDispatch();
  const stores = useSelector((state) => state?.stores?.data);
  const email = useSelector((state) => state?.auth?.profile?.emailid);
  const syncProductsInfo = useSelector((state) => state?.syncProducts);
  const [products, setProducts] = useState([]);
  const [selectedTab, setSelectedTab] = useState(
    syncProductsInfo?.tabIndex || 0
  );
  const [syncedProductsCount, setSyncedProductsCount] = useState(0);
  const [totalProductsCount, setTotalProductsCount] = useState(0);

  useEffect(async () => {
    if (stores?.length > 0 && !products?.length) {
      // const index = _.findIndex(stores, {
      //   MarketplaceType: syncProductsInfo?.marketPlaceType,
      // });

      // setSelectedTab(syncProductsInfo?.tabIndex || index);
      if (syncProductsInfo?.tabIndex >= 0 && syncProductsInfo?.pageInfo) {
        // handleTabChange(null, index, true, syncProductsInfo?.pageInfo);
        setSelectedTab(syncProductsInfo?.tabIndex);
        handleTabChange(null, syncProductsInfo?.tabIndex, true);
      } else {
        handleTabChange(null, 0);
      }
    }
  }, [dispatch, stores]);

  const fetchMoreProducts = async (id) => {
    const { MarketplaceType, ShopID } = stores[selectedTab] || {};
    dispatch(updateField(UPDATE_PAGE_INFO, { pageInfo: id }));

    let newProducts =
      MarketplaceType === 'Shopify'
        ? await dispatch(
            getShopifyMoreProducts({
              page_info: id,
              shopName: ShopID,
              user: email,
            })
          )
        : await dispatch(
            getWooMoreProducts({
              page_info: id,
              shopName: ShopID,
              user: email,
            })
          );

    const syncedP = await dispatch(
      syncedProducts({
        shopName: ShopID,
        emailid: email,
      })
    );

    if (!!syncedP?.length) {
      newProducts = newProducts?.map((p) => ({
        ...p,
        synced: !!syncedP?.find((s) => p?.id === s?.id),
      }));
    }

    setProducts(() => newProducts);
  };

  const handleTabChange = async (event, newValue, fetchMore = false) => {
    const { MarketplaceType, ShopID } = stores[newValue] || {};

    dispatch(
      updateField(UPDATE_MARKETPLACE, {
        marketPlaceType: MarketplaceType,
        tabIndex: newValue,
      })
    );

    if (MarketplaceType === 'Shopify') {
      const count = await dispatch(
        getShopifyProductsCount({
          user: email,
          shopName: ShopID,
        })
      );

      const syncedPCount = await dispatch(
        fetchSyncedProductsCount({
          user: email,
          shopName: ShopID,
        })
      );

      let products = fetchMore
        ? await dispatch(
            getShopifyMoreProducts({
              page_info: syncProductsInfo?.pageInfo,
              shopName: ShopID,
              user: email,
            })
          )
        : await dispatch(
            getShopifyProducts({
              user: email,
              shopName: ShopID,
            })
          );

      const syncedP = await dispatch(
        syncedProducts({
          shopName: ShopID,
          emailid: email,
        })
      );

      if (!!syncedP?.length && !!products?.length) {
        products = products?.map((p) => ({
          ...p,
          synced: !!syncedP?.find((s) => p?.id === s?.id),
        }));
      }

      setTotalProductsCount(() => count?.count);
      setSyncedProductsCount(() => syncedPCount?.count);

      setProducts(() => products);
    } else if (MarketplaceType === 'WooCommerce') {
      const syncedPCount = await dispatch(
        fetchSyncedProductsCount({
          user: email,
          shopName: ShopID,
        })
      );

      let products = fetchMore
        ? await dispatch(
            getWooMoreProducts({
              page_info: syncProductsInfo?.pageInfo,
              shopName: ShopID,
              user: email,
            })
          )
        : await dispatch(
            getWooProducts({
              user: email,
              shopName: ShopID,
            })
          );

      const syncedP = await dispatch(
        syncedProducts({
          shopName: ShopID,
          emailid: email,
        })
      );

      if (!!syncedP?.length && !!products?.length) {
        products = products?.map((p) => ({
          ...p,
          synced: !!syncedP?.find((s) => p?.id === s?.id),
        }));
      }

      setSyncedProductsCount(() => syncedPCount?.count);
      setProducts(() => products);
    } else {
      setProducts(() => []);
    }

    setSelectedTab(newValue);
  };

  const getLabel = ({ MarketplaceType, ShopName }) =>
    MarketplaceType === 'Shopify' || MarketplaceType === 'WooCommerce' ? (
      <div>
        <div style={{ color: '#000', fontWeight: 'bold' }}>
          {MarketplaceType}
        </div>
        <div>{ShopName}</div>
      </div>
    ) : null;

  return (
    <React.Fragment>
      <Tabs
        value={selectedTab}
        onChange={(e, v) => {
          handleTabChange(e, v);
          dispatch(updateField(UPDATE_PAGE_INFO, { pageInfo: null }));
        }}
      >
        {stores?.map((s) => (
          <Tab label={getLabel(s)} key={s?.ID} />
        ))}
      </Tabs>
      {!!products?.length && (
        <Products
          products={products}
          totalProductsCount={totalProductsCount}
          syncedProductCount={syncedProductsCount}
          marketPlaceType={stores[selectedTab]?.MarketplaceType}
          selectedTab={selectedTab}
          shopName={stores[selectedTab]?.ShopID}
          fetchMoreProducts={async (id) => {
            fetchMoreProducts(id);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default ProductTabs;
